import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  addAPIKeyHref: string;
};

/**
 * {@link EmptyAPIKeys} is an empty state for the api-keys page, giving the user a CTA to add an API key.
 */
export function EmptyAPIKeys({ addAPIKeyHref }: Props) {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3">You don’t have any API keys set up</h2>
        <p className="p-lt mb-24">
          API keys allow you to create and delete hosts and lighthouses programmatically, rather than through the admin
          panel.{' '}
          <a
            className="a"
            href="https://www.defined.net/docs/guides/automating-host-creation/"
            target="_blank"
            rel="help"
          >
            Read the guide.
          </a>
        </p>
        <LinkButton to={addAPIKeyHref}>Create API key</LinkButton>
      </div>
    </CenteredLayout>
  );
}
